import { css } from 'linaria';
import { styled } from 'linaria/react';

export const SeasonStartCategoriesContainer = styled.div`
  display: flex;
  gap: 32px;

  @media (--to-desktop) {
    flex-direction: column;
  }

  @media (--only-mobile) {
    row-gap: 24px;
  }

  > div {
    @media (--from-desktop) {
      width: 50%;
    }
  }
`;

export const seasonStartCategoryTitle = css`
  font-weight: 700;
  text-transform: uppercase;
  white-space: break-spaces;
`;

type CategoryCardBgProps = {
  srcLd: string;
  srcD: string;
  srcT: string;
  src: string;
}

export const CategoryCardBg = styled.div<CategoryCardBgProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 32px;
  position: relative;
  background-size: contain;
  border-radius: 20px;
  
  @media (--only-largeDesktop) {
    width: 574px;
  }

  @media (--only-desktop) {
    width: 454px;
  }

  @media (--only-largeDesktop) {
    background-image: ${({ srcLd }: CategoryCardBgProps) => `url(${srcLd})`};
  }
 
  @media (--only-desktop) {
    background-image: ${({ srcD }: CategoryCardBgProps) => `url(${srcD})`};
  }

  @media (--only-tablet) {
    background-image: ${({ srcT }: CategoryCardBgProps) => `url(${srcT})`};
  }

  @media (--only-mobile) {
    background-image: ${({ src }: CategoryCardBgProps) => `url(${src})`};
    background-size: cover;
    width: 100%;
    border-radius: 12px;
    padding: 20px;
  }
`;

export const seasonStartCategoryCardItems = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media (--only-mobile) {
    row-gap: 12px;
  }
`;

export const seasonStartCategoryCardItem = css`
  && {
    display: flex;
    align-items: center;
    column-gap: 12px;
    width: 100%;
    padding: 12px;
    border-radius: var(--rounding-l);
    background-color: var(--background-primary);
  }
`;

export const seasonStartCategoryCardItemTextWrapper = css`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;